import { getResourcePath } from '@spotahome/bff/client';

const getStructuredDataAttributes = () => ({
    name: 'Spotahome',
    url: 'https://www.spotahome.com',
    description: '',
    image: getResourcePath('/images/home/customer-service.jpg'),
    logo: getResourcePath('/bundles/sahapp/images/spotahome-logo--green.svg'),
    address: 'C/ Vizcaya 12, 28045 Madrid - Spain',
    email: 'hello@spotahome.com',
    telephone: '+1 888-950-8805',
    priceRange: '$-$$$',
    sameAs: [
        'https://twitter.com/spotahome',
        'https://facebook.com/spotahome',
        'https://instagram.com/spotahome',
        'https://pinterest.com/spotahome',
        'https://plus.google.com/112987047080252998385'
    ],
    bestRating: 10,
    worstRating: 1,
    ratingValue: 8.7,
    ratingCount: 1596
});

export default getStructuredDataAttributes;
